
const navItems = [
  { label: 'خانه', href: '/' },
  { label: 'فرآیند همکاری', href: '#process' },
  { label: 'سوالات متداول', href: '#faq' }
]

const Header = () => {
  return (
    <header className="w-full border-b border-slate-200/80 bg-transparent">
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-6 px-4 py-3 tablet:px-6 desktop:px-8">
        <nav className="flex items-center gap-8 text-sm font-medium text-slate-700">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="transition-colors duration-200 hover:text-primary-500"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href="/" className="flex items-center" aria-label="home">
            <img
              src="/assets/images/Svg/logo.png"
              alt="logo"
              className="h-[56px] w-[48px] object-contain"
            />
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
